import CloseIcon from '@mui/icons-material/Close';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, IconButton, } from '@mui/material';
import { JSX } from 'react';
import { closeIconStyles, dialogActionsStyles, dialogTitleStyles } from './confirmationDialog.styles';
import { IConfirmationDialogProps } from './confirmationDialog.types';

/**
 * A yes/no question about something already decided elsewhere.
 *
 * Stays a window on a phone while every form dialog in the app goes full-screen. That is
 * deliberate: full-screen reads as "you are now somewhere else, doing a task", which is
 * true of filling in a purchase and false of confirming one sentence. Keeping the page
 * visible behind it also keeps the thing being confirmed in view.
 */
export const ConfirmationDialog = (props: IConfirmationDialogProps): JSX.Element => {
    const onClose = (event: {}, reason: "backdropClick" | "escapeKeyDown"): void => {
        if (reason !== 'backdropClick') {
            props.onClose();
        }
    };

    return (
        <Dialog
            open={props.isOpen}
            onClose={onClose}
            maxWidth="xs"
            fullWidth
            aria-labelledby="cancel-dialog-title"
            aria-describedby="cancel-dialog-description"
        >
            <DialogTitle id="cancel-dialog-title" sx={dialogTitleStyles}>
                {props.title}

                <IconButton aria-label="close" onClick={() => props.onClose()} sx={closeIconStyles}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent>
                <DialogContentText id="cancel-dialog-description">
                    {props.description}
                </DialogContentText>
            </DialogContent>

            <DialogActions sx={dialogActionsStyles}>
                <Button
                    onClick={props.onConfirm}
                    color={props.confirmColor ?? 'error'}
                    variant="contained"
                >
                    {props.confirmMessage}
                </Button>

                <Button
                    onClick={() => props.onClose()}
                    variant='outlined'
                >
                    {props.denyMessage}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
